/**
 *  validation Container: This component return validation schema.
 */
import * as yup from 'yup';

export const schemaManager = (fields: any) => {
    let tempSchema = {};
    fields.length > 0 && fields.forEach((field: any) => {
        if (field.required) {
            tempSchema = {...tempSchema, 
                [field.inputParamKey]: yup.string().required(`${field.name} is required`) 
            }
        }
    });
    tempSchema = {...tempSchema, 
        'selectObject': yup.string().required(`selectObject is required`),
        'selectLayout':yup.string().required(`selectLayout is required`)
        }
    return tempSchema

} 